module.exports = __webpack_public_path__ + "media/images/badges/akt/AKT_BadassLoyaltyProgram_Badges_116x116_2-8b0313dc77edb29a77704fa3175ed5d2.png";